import { IApiRobotConfiguration } from 'src/app/models_new/classes/api-models/ApiRobotConfiguration';

export const defaultApiRobotConfiguration: IApiRobotConfiguration = {
  id: '001',
  scene: null,
  strategy: null,
  name: 'Default robot config',
};
